export const OFF = 0,
  ON = 1,
  EXCLUDE = 2;
